import { AnchorHTMLAttributes, ComponentProps, PropsWithChildren, ReactNode } from "react"
import styles from "./LinkButton.module.css"
import { IntlLinkProps, Link } from '@/i18n/navigation'

export enum LinkButtonSize {
  LARGE,
  MEDIUM,
  SMALL
}

export enum LinkButtonKind {
  PRIMARY,
  SECONDARY,
  SUGGESTED,
  DISCOUNT
}

type LinkButtonProps = {
  size?: LinkButtonSize
  kind?: LinkButtonKind
  href: string
  children: ReactNode
  internal?: boolean
  destructive?: boolean,
  target?: string,
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  Partial<IntlLinkProps>

export default function LinkButton({ internal, target, href, className, children, kind=LinkButtonKind.PRIMARY, size = LinkButtonSize.SMALL, destructive = false, ...props }: PropsWithChildren<LinkButtonProps>) {
  const isInternal = internal ?? (typeof href === "string" && href.startsWith("/"))

  if (isInternal) {
    return (
      <Link href={href}
        className={`
          ${styles.main}
          ${size === LinkButtonSize.SMALL ? 'smallButton' : size === LinkButtonSize.LARGE ? 'largeButton' : 'mediumButton'}
          ${kind === LinkButtonKind.SUGGESTED ? styles.suggested : kind === LinkButtonKind.DISCOUNT ? styles.discount : kind === LinkButtonKind.SECONDARY ? styles.secondary : styles.primary}
          ${className ?? ''}
          ${destructive ? styles.destructive : ''}
        `}
        {...props}
      >
        {children}
      </Link>
    )
  }
  return (
      <a href={href}
        rel='noreferrer'
        target={target}
        className={`
          ${styles.main}
          ${size === LinkButtonSize.SMALL ? 'smallButton' : size === LinkButtonSize.LARGE ? 'largeButton' : 'mediumButton'}
          ${kind === LinkButtonKind.SUGGESTED ? styles.suggested : kind === LinkButtonKind.DISCOUNT ? styles.discount : kind === LinkButtonKind.SECONDARY ? styles.secondary : styles.primary}
          ${className ?? ''}
          ${destructive ? styles.destructive : ''}
        `}
         {...props}>
        {children}
      </a>
  );
}
